import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { supabase } from '../lib/supabase';
import Dashboard from '../pages/Dashboard';

export default function ParentOnboardingCheck() {
  const navigate = useNavigate();
  const { user, isLoading: authLoading } = useAuth();
  const [isLoading, setIsLoading] = useState(true);
  const [parentExists, setParentExists] = useState<boolean | null>(null);

  useEffect(() => {
    let isMounted = true;

    async function checkParentExists() {
      if (!user?.email) {
        if (isMounted) {
          navigate('/login');
        }
        return;
      }

      try {
        const { data, error } = await supabase
          .from('parents')
          .select('id')
          .eq('email', user.email)
          .maybeSingle();

        if (isMounted) {
          if (error || !data) {
            // Non-existing user - redirect to onboarding
            setParentExists(false);
            navigate('/onboarding', { replace: true });
          } else {
            // Existing user - show dashboard
            setParentExists(true);
          }
          setIsLoading(false);
        }
      } catch (error) {
        console.error('Error in parent check:', error);
        if (isMounted) {
          setParentExists(false);
          navigate('/onboarding', { replace: true });
          setIsLoading(false);
        }
      }
    }

    if (!authLoading) {
      checkParentExists();
    }

    return () => {
      isMounted = false;
    };
  }, [user, authLoading, navigate]);

  if (authLoading || isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900" role="progressbar" />
      </div>
    );
  }

  if (!user) {
    return null; // Navigation will handle redirect
  }

  // Show dashboard if parent exists
  if (parentExists === true) {
    return <Dashboard />;
  }

  return null; // Navigation will handle redirect
} 